import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ManagerLoadingHistoryService {
  private storeLoadingHistorySubject = new BehaviorSubject<
    Map<string, boolean>
  >(new Map());

  addOrUpdateLoadingHistory(service: string, loading: boolean) {
    const store = this.storeLoadingHistorySubject.getValue();
    store.set(service, loading);
    this.storeLoadingHistorySubject.next(store);
  }

  removeLoadingHistory(service: string) {
    const store = this.storeLoadingHistorySubject.getValue();
    store.delete(service);
    this.storeLoadingHistorySubject.next(store);
  }

  getItemLoadingHistory(service: string): {
    loading: boolean;
    error: string | null;
  } {
    const store = this.storeLoadingHistorySubject.getValue();
    const item = store.get(service);
    if (!item) return { loading: false, error: 'No se encontro el servicio' };
    return { loading: item, error: null };
  }

  getItemLoadingHistoryDinamic(service: string): Observable<boolean> {
    return this.storeLoadingHistorySubject.pipe(
      filter((store) => store.has(service)),
      map((store) => store.get(service) ?? false)
    );
  }
}
